<style lang="scss" scoped>
::v-deep .invalid-feedback {
  display: block;
}
</style>
<template>
  <div>
    <div class="row">
      <div class="col pl-3">
        <autocomplete
          v-model="postcode"
          url="/api/v1/register/validate-step/1/autocomplete"
          requestType="get"
          property="location"
          :inputClass="hasErrors ? 'form-control is-invalid' : 'form-control'"
          :threshold="2"
          @input="select"
        ></autocomplete>
        <div
          v-if="hasErrors"
          v-for="error in attribute.errors"
          :key="error"
          class="invalid-feedback"
        >
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Autocomplete from "autocomplete-vue";

export default {
  components: {
    Autocomplete
  },
  props: {
    value: {
      required: true
    },
    attribute: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      postcode: ""
    };
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    options() {
      return this.attribute.options;
    }
  },

  methods: {
    select() {
      this.$emit("input", this.postcode);
    }
  }
};
</script>
